<template>
  <!-- ╔═══════════════════════════╗
       ║     SECTION 1 : HERO      ║
       ╚═══════════════════════════╝ -->
  <section
    id="hero"
    class="d-flex align-center justify-center"
    style="min-height: calc(100vh - 84px); margin-top: 0; padding-top: 0"
  >
    <v-container class="fill-height py-0">
      <v-row align="center" justify="center" class="ma-0">
        <v-col cols="12" md="8" order="2" order-md="1">
          <h1
            :class="[
              'font-weight-bold mb-6',
              $vuetify.breakpoint.mdAndUp ? 'display-3' : 'text-h4',
            ]"
          >
            {{ $t("hero_title") }}
          </h1>
          <div
            :class="[
              'mb-8',
              $vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6',
            ]"
            style="font-weight: 300; line-height: 1.6"
            data-aos="fade-left"
          >
            {{ $t("hero_sub") }}
          </div>
          <div class="d-flex flex-column flex-sm-row ga-4">
            <v-btn
              large
              depressed
              color="primary"
              :block="$vuetify.breakpoint.xsOnly"
              :to="{ name: 'register' }"
              >{{ $t("hero_btn_primary") }}</v-btn
            >
            <v-btn
              large
              depressed
              outlined
              color="primary"
              :block="$vuetify.breakpoint.xsOnly"
              @click="$vuetify.goTo('#solution')"
              >{{ $t("hero_btn_secondary") }}</v-btn
            >
          </div>
        </v-col>

        <v-col cols="12" md="4" order="1" order-md="2" class="text-center">
          <v-img
            :src="'/' + $t('home_head_img')"
            :max-width="$vuetify.breakpoint.smAndDown ? '220' : '300'"
            class="pulsate mx-auto"
            contain
          ></v-img>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->

<script>
import Vue from "vue";

export default Vue.extend({
  name: "hero-section",
});
</script>
